<template>
  <div class="userInfo">
    <div class="container">
      <div class="content">
        <div class="menber">
          <div class="item">
            <div class="left">
              <span class="name">头像：</span>
              <img :src="memberInfo.headPicPath" class="men-img" />
              <el-upload
                class="avatar-uploader"
                action="https://www.1778hw.com/cms/file/upload.do"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
              >
                <div class="buttom">修改头像</div>
              </el-upload>
              <!-- </van-uploader> -->
            </div>
          </div>
          <div class="item">
            <span class="name">昵称：</span>
            <input type="text" v-model="memberInfo.name" placeholder class="inputs" />
          </div>
          <div class="item">
            <span class="name">真实姓名：</span>
            <input type="text" v-model="memberInfo.username" placeholder class="inputs" />
          </div>
          <div class="item">
            <span class="name">手机号码：</span>
            <input type="text" v-model="memberInfo.mobile" placeholder class="inputs" />
          </div>
          <!-- <div class="item">
            <span class="name">账号密码：</span>
            <input type="password" v-model="password" placeholder class="inputs" />
          </div>-->
          <div class="buttoms" @click="editInfo">修改</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import VueCoreImageUpload from "vue-core-image-upload";
export default {
  name: "userInfo",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      name: "秋小鱼~",
      password: "123456"
    };
  },
  components: {
    VueCoreImageUpload
  },
  computed: {
    memberInfo() {
      return this.$store.state.memberInfo;
    }
  },
  methods: {
    getNav(index) {
      this.nav = index;
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.memberInfo.headPicPath = res.message[0].fileName;
    },
    editInfo() {
      let params = {
        headpic: this.memberInfo.headPicPath,
        name: this.memberInfo.name,
        username:this.memberInfo.username,
        mobile: this.memberInfo.mobile
      };
      axios
        .post("/mobile/member/update.jhtml", qs.stringify(params))
        .then(res => {
          if (res.data.success) {
            this.$message({
              message: "修改成功~",
              type: "success",
              duration: 1500,
              center: true
            });
            this.$store.dispatch("getMember");
          } else {
            this.$message({
              message: "系统繁忙，请稍后再试~",
              duration: 1500,
              type: "warning",
              center: true
            });
          }
        });
    },
    handleCurrentChange(val) {},
    handleSizeChange(val) {
      console.log("当前页:" + val);
    }
  },
  mounted() {},
  created() {}
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
}
.container {
  text-align: left;
  margin-bottom: 20px;
}
.content {
  width: 100%;
}

.menber {
  width: 70%;
  /* height: 240px; */
  box-shadow: 0px 0px 6px #c7c6c6;
  margin: 20px auto;
  border-radius: 6px;
  padding: 20px 50px;
  box-sizing: border-box;
}
.item {
  display: flex;
  margin: 20px auto;
  align-items: center;
  width: 100%;
}
.left {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 30px;
  border-bottom: 1px solid #cccccc;
}
.name {
  text-align: right;
  display: block;
  width: 80px;
  margin-right: 20px;
  color: #666666;
}
.men-img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
}
.buttom {
  cursor: pointer;
  position: absolute;
  right: 0;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  background: #007741;
  color: #ffffff;
  font-size: 14px;
}
.buttom:hover {
  background: #069e5a;
}
.buttoms:hover {
  background: #069e5a;
}
.buttoms {
  cursor: pointer;
  width: 80px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  background: #007741;
  color: #ffffff;
  font-size: 14px;
  margin: 0 auto;
}
.inputs {
  border: 1px solid #cccccc;
  flex: 1;
  padding: 10px;
  border-radius: 4px;
  color: #666666;
}
</style>
<style>
.van-uploader__input-wrapper {
  position: static !important;
}
</style>


// WEBPACK FOOTER //
// src/components/userview/userInfo.vue